export default __webpack_public_path__ + "static/media/guitar_inactive.beedc1f6.svg";